//import { LoadingRequest, LoadingResponse } from '../../Components/Loding';
import Axios from "../Config/API";
import {
    LoginOrganizacao,
    Login,
    TokenAccess,
} from "../../Interfaces/Login/LoginInterface";
import { Organizacao } from "../../Interfaces/Login/OrganizacaoInterface";
import Service from "../Service";

export async function doLoginOrganizacao(props: LoginOrganizacao) {
    //LoadingRequest(Axios);
    //LoadingResponse(Axios);
    const response = await Axios.post<Array<Organizacao>>(
        `/Home/Authenticate/LoginOrganizacao`,
        props
    )
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function doLoginUsuario(props: Login) {
    //LoadingRequest(Axios);
    //LoadingResponse(Axios);
    const response = await Axios.post<TokenAccess>(
        `/Home/Authenticate/login`,
        props
    )
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function EmailRecuperarSenhaService(email: string) {
    const response = await Axios.get(
        `/home/authenticate/envioemailrecuperacaosenha?email=${email}`
    )
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function AlterarSenhaService(
    password: string,
    cPassword: string,
    token: string
) {
    Axios.interceptors.request.use((config) => {
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });
    const response = await Axios.put(
        `/home/authenticate/alterarsenha?SenhaAntiga=${password}&SenhaNova=${cPassword}`
    )
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function CriarNovaSenhaService(SenhaNova: string, token: string) {
    Axios.interceptors.request.use((config) => {
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });
    return Service(
        Axios.put(`/home/authenticate/crianovasenha?SenhaNova=${SenhaNova}`)
    );
}
